import { BrowserBrand, BrowserEngine, BrowserInfo } from './browser-detection';

export type UnsupportedReason =
  | 'browser_firefox'
  | 'browser_duckduckgo'
  | 'missing_webrtc'
  | 'missing_get_user_media';

export interface CompatibilityResult {
  isSupported: boolean;
  reasons: UnsupportedReason[];
}

export function webRtcSupported(): boolean {
  return !!window.RTCPeerConnection;
}

export function checkVonageCompatibility(browser: BrowserInfo): CompatibilityResult {
  const reasons: UnsupportedReason[] = [];

  if (browser.engine === BrowserEngine.gecko) {
    reasons.push('browser_firefox');
  }
  if (browser.brand === BrowserBrand.duckduckgo) {
    reasons.push('browser_duckduckgo');
  }
  if (!webRtcSupported()) {
    reasons.push('missing_webrtc');
  }
  if (!navigator.mediaDevices?.getUserMedia) {
    reasons.push('missing_get_user_media');
  }
  return { isSupported: reasons.length === 0, reasons };
}
